/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface DutyScheduleWeekdayPreferenceResponse
 */
export interface DutyScheduleWeekdayPreferenceResponse {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof DutyScheduleWeekdayPreferenceResponse
     */
    weekday: DayOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleWeekdayPreferenceResponse
     */
    aw12: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleWeekdayPreferenceResponse
     */
    aw3: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleWeekdayPreferenceResponse
     */
    court: boolean;
}



/**
 * Check if a given object implements the DutyScheduleWeekdayPreferenceResponse interface.
 */
export function instanceOfDutyScheduleWeekdayPreferenceResponse(value: object): value is DutyScheduleWeekdayPreferenceResponse {
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('aw12' in value) || value['aw12'] === undefined) return false;
    if (!('aw3' in value) || value['aw3'] === undefined) return false;
    if (!('court' in value) || value['court'] === undefined) return false;
    return true;
}

export function DutyScheduleWeekdayPreferenceResponseFromJSON(json: any): DutyScheduleWeekdayPreferenceResponse {
    return DutyScheduleWeekdayPreferenceResponseFromJSONTyped(json, false);
}

export function DutyScheduleWeekdayPreferenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleWeekdayPreferenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'aw12': json['aw12'],
        'aw3': json['aw3'],
        'court': json['court'],
    };
}

export function DutyScheduleWeekdayPreferenceResponseToJSON(json: any): DutyScheduleWeekdayPreferenceResponse {
    return DutyScheduleWeekdayPreferenceResponseToJSONTyped(json, false);
}

export function DutyScheduleWeekdayPreferenceResponseToJSONTyped(value?: DutyScheduleWeekdayPreferenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': DayOfWeekToJSON(value['weekday']),
        'aw12': value['aw12'],
        'aw3': value['aw3'],
        'court': value['court'],
    };
}

